import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Link } from 'gatsby-link';

const Arrow = ({ arrowSize = 17, arrowColor }) => {
	const theme = useTheme();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={arrowSize}
			height={arrowSize / 2}
			viewBox="0 0 17 8"
			fill="none"
		>
			<path
				d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4V4.5H16V4V3.5H0V4Z"
				fill={arrowColor || theme.colors.black.main}
			/>
		</svg>
	);
};

const ArrowLinkStyle = styled(Link)`
	color: ${({ theme, linkColor }) => linkColor || theme.colors.black.main};
	font-family: ${({ theme }) => theme.fonts.subheadingMedium};
	font-size: 1.6rem;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.8rem 8px;
	line-height: 100%; /* 16px */
	letter-spacing: 0.16px;
	trainsition: color 0.5s ease;

	&:hover {
		// If there is a specific link color, keep the same unless specified with a different hover color
		color: ${({ theme, hoverColor }) =>
			hoverColor || theme.colors.primary.main};
	}
`;

const ArrowLinkWrapper = styled.div`
	svg {
		transition: transform 0.2s;
	}
	&:hover {
		svg {
			transform: translateX(4px);

			path {
				fill: ${({ theme, hoverColor, linkColor }) =>
					linkColor || hoverColor || theme.colors.primary.main};
			}
		}
	}
`;

const ArrowLink = ({
	link,
	linkText,
	linkColor,
	hoverColor,
	arrowSize,
	className,
	...props
}) => {
	return (
		<ArrowLinkWrapper {...props} className={`arrow-link__wrapper ${className}`}>
			<ArrowLinkStyle to={link} linkColor={linkColor} hoverColor={hoverColor}>
				{linkText}
				<Arrow arrowColor={linkColor} arrowSize={arrowSize} />
			</ArrowLinkStyle>
		</ArrowLinkWrapper>
	);
};

export default ArrowLink;
